module.exports = __webpack_public_path__ + "static/media/pyshical-card.503903bb.svg";